import React, { useState } from 'react';
import Message from '../../molecules/Message';
import ServerChatUI from '../../../modules/chat-ui-server';
import LocalChatUI from '../../../modules/chat-ui-local';
import { ChatModule } from '@mlc-ai/web-llm';
import InputBox from '../../molecules/InputBox';
import { GoArrowSwitch } from "react-icons/go";
import SwitchButton from '../../atoms/Button/SwitchButton';

const Chat = () => {
  const [messages, setMessages] = useState<{ kind: string; text: string }[]>(
    []
  );
  const [prompt, setPrompt] = useState('');
  const [runtimeStats, setRuntimeStats] = useState('');
  const [chat_ui, setChatUI] = useState<ServerChatUI | LocalChatUI>(new ServerChatUI(new ChatModule()));
  const [chat_ui_toggle, setChatUiToggle] = useState('server');

  const updateMessage = (kind: string, text: string, append: boolean) => {
    if (kind == 'init') {
      text = '[System Initalize] ' + text;
    }
    if (append) {
      setMessages((prev) => {
        return [...prev, { kind, text }];
      });
    } else {
      setMessages((prev) => {
        let cpMsgs = [...prev];
        if (!cpMsgs.length) return [{ kind, text }];
        cpMsgs[cpMsgs.length - 1] = { kind, text };
        return cpMsgs;
      });
    }
  };
  
  const clearMessages = () => {
    setMessages([]);
  }

  const inputOnChange = (event) => setPrompt(event.target.value);
  const inputOnKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      setPrompt('');
      chat_ui
        .onGenerate(prompt, updateMessage, setRuntimeStats)
        .catch((error) => console.log(error));
    }
  };

  const inputSend = () => {
    setPrompt('');
    chat_ui
      .onGenerate(prompt, updateMessage, setRuntimeStats)
      .catch((error) => console.log(error));
  };

  const switchServerLocal = async () => {
    setChatUiToggle("loading...");
    await chat_ui.
      onReset(clearMessages);

    if (chat_ui_toggle == "server") {
      setChatUI(new LocalChatUI(new ChatModule()));
      setChatUiToggle("local");
    } else if (chat_ui_toggle == "local") {
      setChatUI(new ServerChatUI(new ChatModule()))
      setChatUiToggle("server");
    } else {
      console.log("error: undefined chat_ui type")
      setChatUiToggle("server");
    }
  }

  return (
    <div className="h-screen w-screen overflow-x-hidden">
      <div className="pb-[120px]">
        {messages.map((value, idx) => (
          <Message text={value.text} type={value.kind} key={idx} />
        ))}
      </div>
      <InputBox
        onChange={inputOnChange}
        onKeyDown={inputOnKeyDown}
        onSend={inputSend}
        value={prompt}
        progress={!chat_ui.requestInProgress}
      />
      <SwitchButton onClick={switchServerLocal} switchText={chat_ui_toggle} />
    </div>
  );
};

export default Chat;
